import {
  type LayerKey,
  type Tree,
  useFetchWorkspaceErrors,
  type WorkspaceKey,
} from '@festina-life/api'
import type { Optional } from '@festina-life/core'
import { keepPreviousData } from '@tanstack/react-query'

import { useConfigurationComponentAvailability } from '../../hooks/useConfigurationComponentAvailability'

export const useWorkspaceErrorsOnAllLayers = ({
  workspaceKey,
  enabled,
  allLayers,
  blockTopology,
  allBlocks,
  layerTopology,
}: {
  workspaceKey: Optional<WorkspaceKey>
  enabled?: boolean
  allLayers: LayerKey[]
  allBlocks: string[]
  layerTopology: Optional<Tree>
  blockTopology: Optional<Tree>
}) => {
  const isConfigurationComponentAvailable =
    useConfigurationComponentAvailability()

  return useFetchWorkspaceErrors(
    {
      workspaceName: workspaceKey?.name,
      server: workspaceKey?.branchKey.server,
      layers: allLayers,
      layerTopology,
      blockTopology,
      blocks: allBlocks,
    },
    {
      enabled:
        enabled !== false &&
        !!isConfigurationComponentAvailable &&
        !!workspaceKey,
      placeholderData: keepPreviousData,
      staleTime: Infinity,
    },
  )
}
